export default "__VITE_PUBLIC_ASSET__c392b3d6__"